import { type ReactNode, useEffect } from 'react';
import { useThemeStore, applyTheme } from './theme-store';

/** Applies the stored theme and re-applies on OS preference change while in `system` mode. */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const mode = useThemeStore((s) => s.mode);

  useEffect(() => {
    applyTheme(mode);
    if (mode !== 'system') return;
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => applyTheme('system');
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [mode]);

  return <>{children}</>;
}
